import { a as D, b as T } from "./addMonths-BDf46gmB.mjs";
import { t as y, c as A } from "./format-plq8pBNY.mjs";
function b(s, c) {
  const {
    years: t = 0,
    months: o = 0,
    weeks: n = 0,
    days: a = 0,
    hours: r = 0,
    minutes: i = 0,
    seconds: m = 0
  } = c, d = y(s), e = o || t ? D(d, o + t * 12) : d, h = a || n ? T(e, a + n * 7) : e, u = i + r * 60, f = (m + u * 60) * 1e3;
  return A(s, h.getTime() + f);
}
export {
  b as a
};
